// Components==============
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import RootReflectionModal from 'components/UI/RootReflectionModal/RootReflectionModal';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import React, { useContext } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { GlobalRootDreamContext } from 'utilities/GlobalContext/GlobalRootDream';
import { sortOnName } from 'utilities/sortOnName';
import '../StudentOverview.module.scss';
// =========================

export default function Dreams() {
  const dreams = useRedux((state) =>
    state.dream?.entities.allIds.map((id) => state.dream?.entities.byId[id])
  );

  const { setRootDreamModal } = useContext(GlobalRootDreamContext);

  return (
    <>
      <motion.div {...framerFade} styleName="wrapper">
        {sortOnName(dreams)?.map(
          (dream) =>
            dream && (
              <ReflectionIcon
                key={dream?.id}
                name={dream?.name}
                image={dream?.image}
                onClick={() => setRootDreamModal({ dream, origin: 'view' })}
              />
            )
        )}
      </motion.div>
      <RootReflectionModal type="dream" />
    </>
  );
}
